import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "../lib/api";
import type { Tenant } from "@shared/types";

interface TenantState {
  currentTenantId: string | null;
  available: Tenant[];
  setTenant: (id: string) => void;
  loadAvailable: () => Promise<void>;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenantId: null,
      available: [],
      setTenant: (id) => set({ currentTenantId: id }),
      loadAvailable: async () => {
        const list = await api<Tenant[]>("/api/tenants");
        set((s) => ({
          available: list,
          // La sélection persistée (localStorage) peut pointer un établissement
          // auquel le compte connecté n'a pas accès — ex. un client qui se
          // connecte sur un navigateur ayant servi à une session admin. Dans ce
          // cas on retombe sur le premier établissement autorisé, sinon toutes
          // les pages interrogent un tenant interdit (403 / listes vides).
          currentTenantId:
            s.currentTenantId && list.some((t) => t.id === s.currentTenantId)
              ? s.currentTenantId
              : (list[0]?.id ?? null),
        }));
      },
    }),
    { name: "vr-tenant", partialize: (s) => ({ currentTenantId: s.currentTenantId }) },
  ),
);
